module.exports = __webpack_public_path__ + "img/icon-sliders.9aff03a5.svg";